module.exports = __webpack_public_path__ + "media/images/searches/map-ef493a3153d5d381d4e44d01bf281b99.svg";